/** Typed wrapper over fetch for /api/broker/fyers/* (ST-5).
 *
 * Fyers auth mirrors Kite: `login` returns a JSON `{login_url}` to send
 * the browser to; the callback lands back on `/broker?fyers_connected=1`.
 * Response shapes are identical to Kite's, so the Kite types are reused.
 * Fyers has no positions endpoint yet, so the account row shows 0 open
 * positions.
 */

import { getJson } from "@/lib/http";
import type { KiteLoginUrl, KiteLtp, KiteStatus } from "@/types/broker";

const BASE = "/api/broker/fyers";

export const fyersApi = {
  loginUrl(): Promise<KiteLoginUrl> {
    return getJson<KiteLoginUrl>(`${BASE}/login`);
  },
  status(): Promise<KiteStatus> {
    return getJson<KiteStatus>(`${BASE}/status`);
  },
  logout(): Promise<KiteStatus> {
    return getJson<KiteStatus>(`${BASE}/logout`, { method: "POST" });
  },
  ltp(symbol: string): Promise<KiteLtp> {
    return getJson<KiteLtp>(`${BASE}/ltp?symbol=${encodeURIComponent(symbol)}`);
  },
};
